import React from 'react'
import "../Home/Home.css"
const Home = () => {
  return (
    <div>
        <div className='subcontainer'>
      <div className='left'>
             <img src="photos/mahaveer.png" alt="" />
      </div>

  <div className='right'> 
     <ul className='listNamokarMantra'>
        <li className='namoArihantanam'>णमो अरिहंताणं</li>
        <li className='namoSidhanam'>णमो सिद्धाणं </li>
        <li className='namoAyriyanam'>णमो आयरियाणं </li>
        <li className='namoUvjhayanam'>णमो उवज्झायाणं</li>
        <li>णमो लोए सव्वसाहुणं</li>
        <li className='aisopanch'>एसो पंच णमुक्कारो, सव्व पाव प्पणासणो | </li>
        
        <li className='aisopanch'> मंगलाणं च सव्वेसिं, पढमं हवई मंगलं ||  </li>
        
    </ul>
  
      </div>
      </div>
      


    </div>
  )
}

export default Home